import { getPathSliceFromIndex } from "../url/getPathSliceFromIndex";

export function removeLocaleFromPath(path: string, locale: string) {
  const segments = getPathSliceFromIndex(path, 0).split("/");
  return "/" + segments.filter((segment) => segment !== locale).join("/");
}
